import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

const HomePage = React.lazy(() => import('../pages/HomePage'));
const ProductFeaturesPage = React.lazy(() => import('../pages/Features/ProductFeaturesPage'));
const PricingPage = React.lazy(() => import('../pages/Pricing/PricingPage'));
const CustomerCasesPage = React.lazy(() => import('../pages/CaseStudies'));
const FAQPage = React.lazy(() => import('../pages/FAQ/FAQPage'));

const PageLoading: React.FC = () => (
  <div style={{ display: 'flex', minHeight: '50vh', alignItems: 'center', justifyContent: 'center', color: '#94a3b8' }}>
    页面加载中...
  </div>
);

const AppRoutes: React.FC = () => {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/features" element={<ProductFeaturesPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/case-studies" element={<CustomerCasesPage />} />
        <Route path="/cases" element={<CustomerCasesPage />} />
        <Route path="/faq" element={<FAQPage />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
